module.exports = __webpack_public_path__ + "assets/img/ea17898dcde9b048d1bccef16bbf007f.png";